import { TableColumn } from 'react-data-table-component';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import { Breakpoints } from 'hooks/Screen/useScreenSize';
import { TrapData } from 'api/traps/Hubs/types';
import BattaryCell from 'components/TrapsTables/Cells/BattaryCell/BattaryCell';
import LinkCell from 'components/TrapsTables/Cells/LinkCell/LinkCell';
import DeviceLinkCell from 'components/TrapsTables/Cells/LinkCell/DevicesLinkCall';
import ConnectionCell from 'components/TrapsTables/Cells/ConnectionCell';
import { useQRCodeModalStore } from 'components/QRCodeModal/QRCodeModal';
import { useTrapDeleteModalStore } from 'components/DeleteTrapModal/TrapsDeleteModal';

export const useGetHubDSBSTableColumns = (slug: string): TableColumn<TrapData>[] => {
  const { t } = useTranslation();
  const { onQRCodeModalOpen } = useQRCodeModalStore();
  const { openDeleteTrapModal } = useTrapDeleteModalStore();

  return [
    {
      name: <i className="ri-wifi-fill fs-16" />,
      selector: row => row.connection_status,
      sortable: true,
      sortField: 'connection_status',
      cell: row => <ConnectionCell status={row.connection_status} />,
      width: '75px',
    },
    {
      name: <i className="ri-battery-charge-fill fs-17" />,
      selector: row => row.battery_percentage,
      sortable: true,
      sortField: 'battery_percentage',
      cell: row => <BattaryCell percentage={row.battery_percentage || 0} />,
      width: '75px',
      style: { justifyContent: 'center' },
    },
    {
      name: t('TrapTables.Number'),
      selector: row => row.sequence_number,
      sortable: true,
      sortField: 'sequence_number',
      cell: row => (
        <LinkCell
          title={String(row.sequence_number) || 'None'}
          link={`/trap/srbm/info/${row.slug}`}
          toReact
          icon="ri-eye-line"
        />
      ),
      grow: 1,
    },
    {
      name: t('TrapTables.InteractiveMap'),
      selector: row => row.default_plan?.url_ending || '',
      cell: row => <DeviceLinkCell data={row.default_plan ?? null} icon="ri-treasure-map-line" slug={slug} />,
      grow: 2,
      hide: Breakpoints.ExtraLarge,
    },
    {
      name: t('TrapTables.LastConnection'),
      selector: row => (row?.last_connect ? dayjs(row.last_connect).format('YYYY-MM-DD\xa0\xa0\xa0HH:mm') : '-'),
      sortable: true,
      sortField: 'last_connect',
      hide: Breakpoints.Tablet,
    },
    {
      name: 'Actions',
      selector: row => row.serial_number,
      hide: Breakpoints.Mobile,
      cell: row => (
        <div>
          <button
            type="button"
            className="btn btn-sm btn-ghost-primary btn-icon"
            onClick={() => openDeleteTrapModal(row.id, row.serial_number, true)}
          >
            <i className="ri-delete-bin-6-fill" />
          </button>
          <button
            type="button"
            className="btn btn-sm btn-ghost-primary btn-icon"
            onClick={() =>
              onQRCodeModalOpen(`${process.env.REACT_APP_BASE_DJANGO_URL}${row?.qr_code}`, row?.serial_number)
            }
          >
            <i className="ri-qr-code-fill text-dark icon icon__qr-code" />
          </button>
        </div>
      ),
    },
  ];
};
